"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@ngx-translate/core");
const app_service_1 = require("@src/app/commons/app.service");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
class QuickGuidesComponent {
    constructor(translate, uiManager, appService) {
        this.translate = translate;
        this.uiManager = uiManager;
        this.appService = appService;
        this.context = null;
        // we also use this as a class modifier to the quick-guide CSS, so if it's on the dashboard/projects we can style the box a bitt different
        this.guidesMode = 'map';
        this.currentGuide = null;
        this.currentGuideTemplate = null;
        this.currentGuideTemplates = null;
        this.currentStep = null;
        this.maxSteps = null;
        this.hoverGuides = {};
        this.marker = null;
        this.guides = [];
        this.canSize = false;
        this.dashboardGuideTemplates = {
            'MAP.GUIDES_DASHBOARD.INTRO': [
                { text: 'SECTION_1', spacer: true },
                { text: 'SECTION_2', gotoGuide: 'MAP.GUIDES_DASHBOARD.SAAS' },
                // { text: 'SECTION_3', gotoGuide:'MAP.GUIDES_DASHBOARD.HOSTED' },
                { text: 'SECTION_4', gotoGuide: 'MAP.GUIDES_DASHBOARD.PLATFORM' },
                { text: 'SECTION_5', gotoGuide: 'MAP.GUIDES_DASHBOARD.PROJECTS' },
                // { text: 'SECTION_6', gotoGuide:'MAP.GUIDES_DASHBOARD.USERS', spacer:true },
                this.appService.showContactUs() ? { button: 'CONTACT_US', gotoGuide: 'MAP.GUIDES_DASHBOARD.CONTACT_US', textAfter: 'MORE_INFO' } : {}
            ],
            'MAP.GUIDES_DASHBOARD.SAAS': [
                //  { runAction:'saas', conditional:'class=large' },
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                    ] },
            ],
            // 'MAP.GUIDES_DASHBOARD.HOSTED': [
            //  { text: 'SECTION_1' },
            //  { button:'GO_BACK', gotoGuide:'MAP.GUIDES_DASHBOARD.INTRO', color:'default' },
            //  { button:'CONTACT_US', gotoGuide:'MAP.GUIDES_DASHBOARD.CONTACT_US', textAfter:'MORE_INFO' }
            // ],
            'MAP.GUIDES_DASHBOARD.PLATFORM': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { text: 'STEP_2_TEXT_2' },
                        { text: 'STEP_2_TEXT_3' },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { text: 'STEP_3_TEXT_2' },
                    ] },
            ],
            'MAP.GUIDES_DASHBOARD.PROJECTS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', click: 'add-project', spacer: true },
                        { text: 'STEP_1_TEXT_2' }
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', click: 'project-favourites', spacer: true }
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', hover: 'project-search', spacer: true },
                        { text: 'STEP_3_TEXT_2' },
                        { button: 'STEP_3_BUTTON_2', click: 'project-sort', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', click: 'project-load', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                        { button: 'STEP_4_BUTTON_2', hover: 'project-select', spacer: true },
                        { text: 'STEP_4_TEXT_3' },
                        { button: 'STEP_4_BUTTON_3', click: 'project_info_load', spacer: true },
                        { text: 'STEP_4_TEXT_4' },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { button: 'STEP_5_BUTTON_1', hover: 'project-options', spacer: true },
                        { text: 'STEP_5_TEXT_2' },
                        { button: 'STEP_5_BUTTON_2', hover: 'project-delete', spacer: true },
                    ] }
            ],
            'MAP.GUIDES_DASHBOARD.CONTACT_US': [
                { text: 'SECTION_1', conditional: 'state=ready' },
                { field: 'text', label: 'NAME', autofill: true, conditional: 'state=ready' },
                { field: 'email', label: 'EMAIL', autofill: true, conditional: 'state=ready' },
                { field: 'hidden', label: 'USER_ID', autofill: true },
                { field: 'hidden', label: 'ACCOUNT_ID', autofill: true },
                { field: 'textarea', label: 'MESSAGE', conditional: 'state=ready' },
                { spinner: true, conditional: 'state=sending' },
                { text: 'SENT', hint: true, conditional: 'state=sent', spacer: true },
                { text: 'SENT_ERROR', hint: true, conditional: 'state=sent_error', spacer: true },
                { button: 'GO_BACK', gotoGuide: 'MAP.GUIDES_DASHBOARD.INTRO', conditional: 'state=sent state=ready state=sent_error', color: 'default' },
                { button: 'SEND', action: 'contact_us', data: 'form', conditional: 'state=ready', color: 'accent' },
            ],
        };
        this.mapGuideTemplates = {
            'MAP.GUIDES.INTRO': [
                { text: 'SECTION_1' },
                { text: 'SECTION_2' },
                { listGuides: true, listSelf: false },
                //    { text:'SECTION_3_HINT_1', hint:true, testButton:true },
                { text: 'SECTION_3' },
                { text: 'SECTION_4' },
                { button: 'SECTION_4_BUTTON_1', click: 'guide-toolbar-help', spacer: true },
            ],
            'MAP.GUIDES.DATA': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', click: 'add-data', spacer: true },
                        { text: 'STEP_1_TEXT_2' },
                        { text: 'STEP_1_TEXT_3' },
                        { text: 'STEP_1_TEXT_4' },
                        { text: 'STEP_1_TEXT_5' },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', click: 'add-data-button', spacer: true },
                        { text: 'STEP_2_TEXT_2' },
                        { text: 'STEP_2_TEXT_3' },
                        { button: 'STEP_2_BUTTON_2', click: 'guide-open-photo-bucket', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', click: 'add-data-button', spacer: true },
                        { text: 'STEP_3_TEXT_2' },
                        { text: 'STEP_3_TEXT_3' },
                        { button: 'STEP_3_BUTTON_2', hover: 'layer-files', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', click: 'add-data-button', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                        { button: 'STEP_4_BUTTON_2', click: 'start-tiling', spacer: true },
                        { text: 'STEP_4_TEXT_3' },
                        { text: 'STEP_4_TEXT_4' },
                        { text: 'STEP_4_TEXT_5' },
                        { button: 'STEP_4_BUTTON_3', hover: 'layer-files', spacer: true },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { button: 'STEP_5_BUTTON_1', click: 'add-data-button', spacer: true },
                        { text: 'STEP_5_TEXT_2' },
                        { button: 'STEP_5_BUTTON_2', click: 'start-tiling', spacer: true },
                        { text: 'STEP_5_TEXT_3' },
                        { text: 'STEP_5_TEXT_4' },
                        { text: 'STEP_5_TEXT_5' },
                        { button: 'STEP_5_BUTTON_3', hover: 'layer-files', spacer: true },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_HINT_1', hint: true },
                        { button: 'STEP_6_BUTTON_1', hover: 'additional-files', spacer: true },
                    ] },
                { step: 7, label: 'STEP_7_LABEL', sections: [
                        { text: 'STEP_7_TEXT_1' },
                        { text: 'STEP_7_TEXT_2' },
                        { text: 'STEP_7_TEXT_3' },
                        { text: 'STEP_7_TEXT_4' },
                        { button: 'STEP_7_BUTTON_1', click: 'add-data-button', spacer: true },
                        { text: 'STEP_7_TEXT_5' },
                        { text: 'STEP_7_TEXT_6' }
                    ] },
            ],
            'MAP.GUIDES.ANNOTATIONS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', click: 'guide-tab-annot', spacer: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { text: 'STEP_2_HINT_1', hint: true },
                        { button: 'STEP_2_BUTTON_1', hover: 'add-shape', spacer: true },
                        { text: 'STEP_2_TEXT_2' },
                        { text: 'STEP_2_TEXT_3' },
                        { text: 'STEP_2_TEXT_4' },
                        { text: 'STEP_2_HINT_2', hint: true },
                        { button: 'STEP_2_BUTTON_2', hover: 'add-shape', spacer: true },
                        { text: 'STEP_2_TEXT_5' },
                        { text: 'STEP_2_HINT_3', hint: true },
                        { button: 'STEP_2_BUTTON_3', hover: 'add-shape', spacer: true },
                        { text: 'STEP_2_TEXT_6' },
                        { button: 'STEP_2_BUTTON_4', click: 'add-another-shape', spacer: true }
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { text: 'STEP_3_TEXT_2' },
                        { button: 'STEP_3_BUTTON_1', hover: 'annotation-notes', spacer: true },
                        { text: 'STEP_3_TEXT_3' },
                        { button: 'STEP_3_BUTTON_2', hover: 'annotation-categories', spacer: true },
                        { text: 'STEP_3_TEXT_4' },
                        { button: 'STEP_3_BUTTON_3', hover: 'annotation-linewidth', spacer: true },
                        { text: 'STEP_3_TEXT_5' },
                        { button: 'STEP_3_BUTTON_4', hover: 'annotation-clamp', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', click: 'annotation-url', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                        { text: 'STEP_4_TEXT_3' },
                        { button: 'STEP_4_BUTTON_2', click: 'annotation-attributes', spacer: true },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { text: 'STEP_5_TEXT_2' },
                        { button: 'STEP_5_BUTTON_1', hover: 'show-labels', spacer: true },
                        { text: 'STEP_5_HINT_1', hint: true },
                        { button: 'STEP_5_BUTTON_2', hover: 'add-shape', spacer: true },
                        { text: 'STEP_5_TEXT_3' },
                        { text: 'STEP_5_TEXT_4' },
                        { button: 'STEP_5_BUTTON_3', click: 'line-profiler', spacer: true },
                        { text: 'STEP_5_HINT_2', hint: true },
                        { button: 'STEP_5_BUTTON_4', hover: 'add-shape', spacer: true },
                        { text: 'STEP_5_TEXT_5' },
                        { button: 'STEP_5_BUTTON_5', click: 'calculate-volume', spacer: true },
                        { text: 'STEP_5_TEXT_6' },
                        { text: 'STEP_5_TEXT_7' }
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' },
                        { button: 'STEP_6_BUTTON_1', hover: 'annotation-search', spacer: true },
                        { text: 'STEP_6_TEXT_2' },
                        { button: 'STEP_6_BUTTON_2', click: 'annotation-deselect', spacer: true },
                        { text: 'STEP_6_TEXT_3' },
                        { button: 'STEP_6_BUTTON_3', hover: 'annotation-filter', spacer: true },
                        { text: 'STEP_6_TEXT_4' },
                        { button: 'STEP_6_BUTTON_4', click: 'annotation-download', spacer: true },
                        { text: 'STEP_6_TEXT_5' },
                        { button: 'STEP_6_BUTTON_5', click: 'annotation-report', spacer: true },
                        { text: 'STEP_6_TEXT_6' },
                        { button: 'STEP_6_BUTTON_6', hover: 'annotation-screenshot', spacer: true },
                        { text: 'STEP_6_TEXT_7' },
                        { button: 'STEP_6_BUTTON_7', click: 'find-images', spacer: true },
                        { text: 'STEP_6_TEXT_8' },
                        { button: 'STEP_6_BUTTON_8', hover: 'fly-camera', spacer: true },
                        { text: 'STEP_6_TEXT_9' },
                        { button: 'STEP_6_BUTTON_9', hover: 'save-view', spacer: true }
                    ] },
                { step: 7, label: 'STEP_7_LABEL', sections: [
                        { text: 'STEP_7_TEXT_1' },
                        { button: 'STEP_7_BUTTON_1', click: 'annotation-delete', spacer: true }
                    ] }
            ],
            'MAP.GUIDES.BOOKMARKS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_HINT_1', hint: true },
                        { button: 'STEP_1_BUTTON_1', hover: 'tab-bookmark', spacer: true },
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                        { text: 'STEP_1_TEXT_3' },
                    ] },
            ],
            'MAP.GUIDES.LAYERS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', click: 'add-layer', spacer: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', hover: 'switch-layer', spacer: true },
                        { text: 'STEP_2_TEXT_2' },
                        { button: 'STEP_2_BUTTON_2', click: 'view-layer', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', click: 'play-layer', spacer: true },
                        { text: 'STEP_3_TEXT_2' },
                        { button: 'STEP_3_BUTTON_2', click: 'split-layer', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', hover: 'switch-layer', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                        { button: 'STEP_4_BUTTON_2', click: 'download-layer', spacer: true },
                        { text: 'STEP_4_TEXT_3' },
                        { button: 'STEP_4_BUTTON_3', click: 'reset-layer', spacer: true },
                        { text: 'STEP_4_TEXT_4' },
                        { button: 'STEP_4_BUTTON_4', click: 'delete-layer', spacer: true },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { button: 'STEP_5_BUTTON_1', hover: 'file-info', spacer: true },
                        { text: 'STEP_5_TEXT_2' },
                        { text: 'STEP_5_TEXT_3' },
                        { button: 'STEP_5_BUTTON_2', hover: 'adjust-layer', spacer: true },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' }
                    ] },
            ],
            'MAP.GUIDES.SETTINGS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', hover: 'scene-plugins', spacer: true },
                        { text: 'STEP_1_TEXT_2' },
                        { text: 'STEP_1_TEXT_3' },
                        { text: 'STEP_1_TEXT_4' },
                        { text: 'STEP_1_TEXT_5' },
                        { text: 'STEP_1_TEXT_6' },
                        { button: 'STEP_1_BUTTON_2', click: 'save-settings', spacer: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_HINT_1', hint: true },
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', click: 'guide-toolbar-account' },
                        { text: 'STEP_2_TEXT_2' },
                        { text: 'STEP_2_TEXT_3' },
                        { text: 'STEP_2_TEXT_4' },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', hover: 'guide-toolbar-teams', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', click: 'guide-toolbar-projects', spacer: true },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { button: 'STEP_5_BUTTON_1', click: 'add-data-button', spacer: true },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' },
                        { button: 'STEP_6_BUTTON_1', hover: 'guide-toolbar-progress', spacer: true }
                    ] },
                { step: 7, label: 'STEP_7_LABEL', sections: [
                        { text: 'STEP_7_TEXT_1' },
                        { button: 'STEP_7_BUTTON_1', click: 'guide-toolbar-help', spacer: true },
                    ] },
                { step: 8, label: 'STEP_8_LABEL', sections: [
                        { text: 'STEP_8_TEXT_1' },
                        { button: 'STEP_8_BUTTON_1', click: 'guide-toolbar-settings', spacer: true },
                        { text: 'STEP_8_TEXT_2' },
                        { text: 'STEP_8_TEXT_3' },
                        { text: 'STEP_8_TEXT_4' },
                        { text: 'STEP_8_TEXT_5' },
                        { text: 'STEP_8_TEXT_6' },
                        { text: 'STEP_8_TEXT_7' },
                    ] },
                { step: 9, label: 'STEP_9_LABEL', sections: [
                        { text: 'STEP_9_TEXT_1' },
                        { button: 'STEP_9_BUTTON_1', click: 'guide-toolbar-user', spacer: true },
                    ] },
            ],
            'MAP.GUIDES.PHOTOGRAMMETRY': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_HINT_1', hint: true },
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', click: 'add-data-button', spacer: true },
                        { text: 'STEP_1_TEXT_2' },
                        { button: 'STEP_1_BUTTON_2', click: 'guide-open-photo-bucket' },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', ask: 'STEP_2_ASK', yes: 3, no: 6, sections: [
                        { text: 'STEP_2_TEXT' }
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { text: 'STEP_3_TEXT_2' },
                        { button: 'STEP_3_BUTTON_1', click: 'guide-open-photogrammetry', spacer: true },
                        { text: 'STEP_3_TEXT_3' },
                        { button: 'STEP_3_BUTTON_2', click: 'guide-open-photogrammetry-setup', spacer: true },
                        { text: 'STEP_3_TEXT_4' },
                        { text: 'STEP_3_TEXT_5' },
                        { text: 'STEP_3_TEXT_6' },
                        { text: 'STEP_3_TEXT_7' },
                        { button: 'STEP_3_BUTTON_3', click: 'guide-open-photogrammetry-preview', spacer: true },
                        { text: 'STEP_3_TEXT_8' },
                        { text: 'STEP_3_TEXT_9' },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', click: 'guide-check-photogrammetry-gcps', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                        { text: 'STEP_4_HINT_1', hint: true },
                        { button: 'STEP_4_BUTTON_2', click: 'guide-open-photogrammetry-gcps', spacer: true }
                    ] },
                { step: 5, label: 'STEP_5_LABEL', goto: 7, sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { text: 'STEP_5_TEXT_2' },
                        { text: 'STEP_5_TEXT_3' },
                        { text: 'STEP_5_TEXT_4' },
                        { button: 'STEP_5_BUTTON_1', click: 'guide-start-photogrammetry', spacer: true },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' },
                        { button: 'STEP_6_BUTTON_1', click: 'guide-tab-processing', spacer: true },
                        { text: 'STEP_6_TEXT_2' },
                        { button: 'STEP_6_BUTTON_2', click: 'guide-processing-Photo23D', spacer: true },
                        { text: 'STEP_6_TEXT_3' },
                    ] },
                { step: 7, label: 'STEP_7_LABEL', sections: [
                        { text: 'STEP_7_TEXT_1' },
                        { button: 'STEP_7_BUTTON_1', click: 'guide-tab-layers', spacer: true },
                    ] },
            ],
            'MAP.GUIDES.PLUGINS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                        { button: 'STEP_1_BUTTON_1', hover: 'scene-plugins', spacer: true },
                        { text: 'STEP_1_TEXT_3' },
                        { button: 'STEP_1_BUTTON_2', hover: 'layer-plugins', spacer: true },
                        { text: 'STEP_1_TEXT_4' },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { text: 'STEP_2_TEXT_2' },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { text: 'STEP_3_HINT_1', hint: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { text: 'STEP_4_TEXT_2' },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { text: 'STEP_5_TEXT_2' },
                        { text: 'STEP_5_TEXT_3' },
                        { text: 'STEP_5_TEXT_4' },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' },
                        { text: 'STEP_6_HINT_1', hint: true },
                    ] },
                { step: 7, label: 'STEP_7_LABEL', sections: [
                        { text: 'STEP_7_TEXT_1' },
                    ] },
                { step: 8, label: 'STEP_8_LABEL', sections: [
                        { text: 'STEP_8_TEXT_1' },
                        { text: 'STEP_8_HINT_1', hint: true },
                        { text: 'STEP_8_TEXT_2' },
                    ] },
                { step: 9, label: 'STEP_9_LABEL', sections: [
                        { text: 'STEP_9_TEXT_1' },
                    ] },
                { step: 10, label: 'STEP_10_LABEL', sections: [
                        { text: 'STEP_10_TEXT_1' },
                    ] },
                { step: 11, label: 'STEP_11_LABEL', sections: [
                        { text: 'STEP_11_TEXT_1' },
                        { text: 'STEP_11_TEXT_2' },
                    ] },
                { step: 12, label: 'STEP_12_LABEL', sections: [
                        { text: 'STEP_12_TEXT_1' },
                        { text: 'STEP_12_TEXT_2' },
                        { text: 'STEP_12_HINT_1', hint: true },
                    ] },
                { step: 13, label: 'STEP_13_LABEL', sections: [
                        { text: 'STEP_13_TEXT_1' },
                        { text: 'STEP_13_HINT_1', hint: true },
                    ] },
                { step: 14, label: 'STEP_14_LABEL', sections: [
                        { text: 'STEP_14_TEXT_1' },
                        { text: 'STEP_14_HINT_1', hint: true },
                    ] },
                { step: 15, label: 'STEP_15_LABEL', sections: [
                        { text: 'STEP_15_TEXT_1' },
                        { button: 'STEP_15_BUTTON_1', hover: 'category-plugin', spacer: true },
                        { text: 'STEP_15_TEXT_2' },
                        { button: 'STEP_15_BUTTON_2', click: 'guide-toolbar-settings', spacer: true },
                        { text: 'STEP_15_TEXT_3' },
                        { text: 'STEP_15_TEXT_4' },
                        { button: 'STEP_15_BUTTON_3', hover: 'layer-plugins', spacer: true },
                        { text: 'STEP_15_TEXT_5' },
                        { button: 'STEP_15_BUTTON_4', click: 'layer-plugins', spacer: true },
                    ] },
                { step: 16, label: 'STEP_16_LABEL', sections: [
                        { text: 'STEP_16_TEXT_1' },
                        { button: 'STEP_16_BUTTON_1', hover: 'pulse-plugin', spacer: true },
                        { text: 'STEP_16_TEXT_2' },
                        { button: 'STEP_16_BUTTON_2', click: 'restore-plugin', spacer: true },
                        { text: 'STEP_16_TEXT_3' },
                        { button: 'STEP_16_BUTTON_3', click: 'disable-plugin', spacer: true },
                    ] },
            ],
            'MAP.GUIDES.SCENES': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', hover: 'default-scene', spacer: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', hover: 'scene-options', spacer: true },
                        { text: 'STEP_2_TEXT_2' },
                        { button: 'STEP_2_BUTTON_2', click: 'scene-options', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', click: 'scene-options', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', click: 'scene-options', spacer: true },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { button: 'STEP_5_BUTTON_1', click: 'scene-options', spacer: true },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' },
                        { button: 'STEP_6_BUTTON_1', hover: 'scene-plugins', spacer: true },
                        { text: 'STEP_6_TEXT_2' },
                        { text: 'STEP_6_TEXT_3' },
                        { button: 'STEP_6_BUTTON_2', click: 'disable-plugin', spacer: true },
                        { text: 'STEP_6_TEXT_4' },
                        { button: 'STEP_6_BUTTON_3', click: 'restore-plugin', spacer: true },
                        { text: 'STEP_6_TEXT_5' },
                    ] },
            ],
            'MAP.GUIDES.SHARING': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_HINT_1', hint: true },
                        { text: 'STEP_1_TEXT_2' },
                        { button: 'STEP_1_BUTTON_1', hover: 'scene-plugins', spacer: true },
                        { text: 'STEP_1_TEXT_3' },
                        { button: 'STEP_1_BUTTON_2', click: 'share-link', spacer: true },
                        { text: 'STEP_1_TEXT_4' },
                        { button: 'STEP_1_BUTTON_3', hover: 'invite-user', spacer: true },
                        { text: 'STEP_1_TEXT_5' },
                        { button: 'STEP_1_BUTTON_4', hover: 'copy-clipboard', spacer: true },
                        { text: 'STEP_1_TEXT_6' },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_HINT_1', hint: true },
                        { text: 'STEP_2_TEXT_2' },
                        { button: 'STEP_2_BUTTON_1', click: 'share-link', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', hover: 'disable-share', spacer: true },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', hover: 'scene-plugins', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                        { button: 'STEP_4_BUTTON_1', hover: 'manage-users', spacer: true },
                        { text: 'STEP_4_TEXT_3' },
                    ] },
            ],
            'MAP.GUIDES.FORMATS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                        { text: 'STEP_1_TEXT_3' },
                        { text: 'STEP_1_TEXT_4' },
                        { text: 'STEP_1_TEXT_5' },
                        { text: 'STEP_1_TEXT_6' },
                        { text: 'STEP_1_TEXT_7' },
                        { text: 'STEP_1_TEXT_8' },
                        { text: 'STEP_1_TEXT_9' },
                        { text: 'STEP_1_TEXT_10' },
                        { text: 'STEP_1_TEXT_11' },
                        { text: 'STEP_1_TEXT_12' },
                        { text: 'STEP_1_TEXT_13' },
                        { text: 'STEP_1_TEXT_14' },
                        { text: 'STEP_1_TEXT_15' },
                        { text: 'STEP_1_TEXT_16' }
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', click: 'guide-toolbar-help', spacer: true },
                    ] },
            ],
        };
        this.accountGuideTemplates = {
            'MAP.GUIDES.ACCOUNT': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { button: 'STEP_1_BUTTON_1', hover: 'account-name', spacer: true },
                        { text: 'STEP_1_TEXT_2' },
                        { button: 'STEP_1_BUTTON_2', hover: 'account-desc', spacer: true },
                        { text: 'STEP_1_TEXT_3' },
                        { button: 'STEP_1_BUTTON_3', click: 'account-image', spacer: true },
                        { text: 'STEP_1_TEXT_4' },
                        { button: 'STEP_1_BUTTON_4', click: 'account-save', spacer: true },
                    ] },
            ],
        };
        this.usersGuideTemplates = {
            'MAP.GUIDES.USERS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                        { button: 'STEP_1_BUTTON_2', click: 'invite-new', spacer: true },
                        { text: 'STEP_1_TEXT_3' },
                        { text: 'STEP_1_TEXT_4' },
                        { text: 'STEP_1_HINT_1', hint: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', click: 'add-projects', spacer: true },
                        { text: 'STEP_2_TEXT_2' },
                        { text: 'STEP_2_HINT_1', hint: true },
                        { text: 'STEP_2_TEXT_3' },
                        { button: 'STEP_2_BUTTON_2', hover: 'remove-user', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', click: 'delete-user', spacer: true },
                    ] },
            ],
        };
        this.explorerGuideTemplates = {
            'MAP.GUIDES.EXPLORER': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                        { button: 'STEP_1_BUTTON_1', click: 'guide-toolbar-explorer', spacer: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { text: 'STEP_2_TEXT_2' },
                        { button: 'STEP_2_BUTTON_1', click: 'guide-toolbar-help', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { button: 'STEP_3_BUTTON_1', click: 'file-upload', spacer: true },
                        { text: 'STEP_3_TEXT_2' },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', hover: 'file-search', spacer: true },
                    ] },
                { step: 5, label: 'STEP_5_LABEL', sections: [
                        { text: 'STEP_5_TEXT_1' },
                        { text: 'STEP_5_TEXT_2' },
                        { text: 'STEP_5_TEXT_3' },
                    ] },
                { step: 6, label: 'STEP_6_LABEL', sections: [
                        { text: 'STEP_6_TEXT_1' },
                        { text: 'STEP_6_TEXT_2' },
                        { text: 'STEP_6_TEXT_3' },
                    ] },
                { step: 7, label: 'STEP_7_LABEL', sections: [
                        { text: 'STEP_7_TEXT_1' },
                        { button: 'STEP_7_BUTTON_1', click: 'add-folder', spacer: true },
                        { text: 'STEP_7_TEXT_2' },
                    ] },
                { step: 8, label: 'STEP_8_LABEL', sections: [
                        { text: 'STEP_8_TEXT_1' },
                        { text: 'STEP_8_TEXT_2' },
                        { text: 'STEP_8_TEXT_3' },
                    ] },
                { step: 9, label: 'STEP_9_LABEL', sections: [
                        { text: 'STEP_9_TEXT_1' },
                        { text: 'STEP_9_TEXT_2' },
                        { text: 'STEP_9_TEXT_3' },
                        { text: 'STEP_9_TEXT_4' },
                    ] }
            ]
        };
        this.planGuideTemplates = {
            'MAP.GUIDES.PLANS': [
                { step: 1, label: 'STEP_1_LABEL', sections: [
                        { text: 'STEP_1_TEXT_1' },
                        { text: 'STEP_1_TEXT_2' },
                        { text: 'STEP_1_HINT_1', hint: true },
                        { button: 'STEP_1_BUTTON_1', hover: 'switch-plan', spacer: true },
                        { text: 'STEP_1_TEXT_3' },
                        { button: 'STEP_1_BUTTON_2', hover: 'adjust-plan', spacer: true },
                        { text: 'STEP_1_TEXT_4' },
                        { button: 'STEP_1_BUTTON_3', hover: 'cancel-plan', spacer: true },
                    ] },
                { step: 2, label: 'STEP_2_LABEL', sections: [
                        { text: 'STEP_2_TEXT_1' },
                        { button: 'STEP_2_BUTTON_1', hover: 'allowance-credits', spacer: true },
                        { text: 'STEP_2_TEXT_2' },
                        { button: 'STEP_2_BUTTON_2', hover: 'purchase-credits', spacer: true },
                    ] },
                { step: 3, label: 'STEP_3_LABEL', sections: [
                        { text: 'STEP_3_TEXT_1' },
                        { text: 'STEP_3_TEXT_2' },
                        { button: 'STEP_3_BUTTON_1', click: 'edit-contact', spacer: true },
                        { text: 'STEP_3_TEXT_3' },
                        { text: 'STEP_3_TEXT_4' },
                        { button: 'STEP_3_BUTTON_2', hover: 'add-card', spacer: true },
                        { text: 'STEP_3_HINT_1', hint: true },
                        { text: 'STEP_3_TEXT_5' },
                        { text: 'STEP_3_TEXT_6' },
                    ] },
                { step: 4, label: 'STEP_4_LABEL', sections: [
                        { text: 'STEP_4_TEXT_1' },
                        { button: 'STEP_4_BUTTON_1', hover: 'invoices-table', spacer: true },
                        { text: 'STEP_4_TEXT_2' },
                    ] },
            ],
        };
        this.guidesClass = '';
        this.state = 'ready';
        // Remove ContactUs for Japan
        if (!this.appService.showContactUs())
            delete this.dashboardGuideTemplates['MAP.GUIDES_DASHBOARD.CONTACT_US'];
    }
    ngOnChanges() {
        this.updateGuide();
    }
    ngOnInit() {
        this.updateGuide();
        this.marker = this.findGuide('quick-guides-marker');
    }
    setState(state = 'ready') {
        this.state = state;
    }
    updateType() {
        // this.type = this.context.constructor.name;
        if (this.guidesMode == 'explorer') {
            this.canSize = false;
        }
        else if (this.guidesMode == 'dashboard') {
            if (!this.context.hasOwnProperty('doShowTipsLarge')) {
                this.context['doShowTipsLarge'] = true;
            }
            this.canSize = true;
            if (this.context['doShowTipsLarge']) {
                this.guidesClass = ' large';
            }
            else {
                this.guidesClass = ' small';
            }
        }
        else {
            this.guidesClass = '';
            this.canSize = false;
        }
        //console.log('ENTER quick guide Projects guidesMode', this.guidesMode, this.guidesClass );
    }
    updateGuide() {
        if (!this.context) {
            const me = this;
            setTimeout(() => { me.updateGuide(); }, 2000);
        }
        this.updateType();
        this.currentStep = 1;
        if (this.guidesMode == 'map') {
            // console.log ('updateGuide() MAP', this.currentGuide, this.currentGuideTemplates, this.guides );
            // this.currentGuide = 'MAP.GUIDES.INTRO';
            this.currentGuideTemplates = this.mapGuideTemplates;
            // this.guides = [ 'MAP.GUIDES.INTRO', 'MAP.GUIDES.GENERIC', 'MAP.GUIDES.PHOTOGRAMMETRY' ];
        }
        else if (this.guidesMode == 'dashboard') {
            // console.log ('updateGuide() DASHBOARD', this.currentGuide, this.currentGuideTemplates, this.guides );
            // this.currentGuide = 'MAP.GUIDES_DASHBOARD.INTRO';
            this.currentGuideTemplates = this.dashboardGuideTemplates;
            // this.guides = [ 'MAP.GUIDES_DASHBOARD.INTRO' ];
        }
        else if (this.guidesMode == 'explorer') {
            this.currentGuideTemplates = this.explorerGuideTemplates;
        }
        else if (this.guidesMode == 'plan') {
            this.currentGuideTemplates = this.planGuideTemplates;
        }
        else if (this.guidesMode == 'users') {
            this.currentGuideTemplates = this.usersGuideTemplates;
        }
        else if (this.guidesMode == 'account') {
            this.currentGuideTemplates = this.accountGuideTemplates;
        }
        this.guides = Object.keys(this.currentGuideTemplates);
        this.currentGuide = this.guides[0];
        // console.log ('updateGuide() SETUP', this.currentGuide, this.currentGuideTemplates, this.currentGuideTemplate );
        this.selectGuide(this.currentGuide);
    }
    selectGuide(cur) {
        // console.log ('selectGuide()', cur, this.currentGuideTemplates );
        // clear current state
        this.setState();
        this.currentGuide = cur;
        // console.log('########', this.currentGuide, this.currentGuideTemplates, this.currentGuideTemplate );
        this.currentGuideTemplate = this.currentGuideTemplates[this.currentGuide];
        let count = 0;
        this.currentGuideTemplate.forEach(me => {
            if (me['step']) {
                count++;
            }
            if (me['runAction']) {
                if (me['conditional']) {
                    if (this.conditional(me['conditional'])) {
                        this.action(me.runAction);
                    }
                }
                else {
                    this.action(me.runAction);
                }
            }
        });
        this.maxSteps = count;
    }
    updateStep() {
        this.currentGuideTemplate.forEach(me => {
            if (me['step'] && me['step'] == this.currentStep) {
            }
        });
    }
    scrollTo() {
        location.hash = "#anchor-step-" + this.currentStep;
    }
    previous() {
        this.currentStep = this.currentStep - 1;
        this.scrollTo();
        // console.log('prev',this.currentStep);
    }
    next(step = null) {
        if (step) {
            this.goto(step);
            return;
        }
        this.currentStep = this.currentStep + 1;
        this.scrollTo();
        // console.log('next',this.currentStep);
    }
    gotoGuide(guide = '') {
        this.selectGuide(guide);
    }
    goto(step = 1) {
        this.currentStep = step;
        this.scrollTo();
        // console.log('goto',this.currentStep);
    }
    done() {
        this.currentGuide = 'MAP.GUIDES.INTRO';
        this.updateGuide();
    }
    click(id = '') {
        // console.log('! click()',id);
        this.clickOn(id);
        if (this.marker) {
            this.marker.classList.add('clicked');
            setTimeout(() => { this.marker.classList.remove('clicked'); }, 1400);
        }
    }
    hover(inp) {
        if (!this.hoverGuides[inp]) {
            this.hoverGuides[inp] = {
                hovering: false
            };
        }
        if (this.hoverGuides[inp].hovering) {
            return;
        }
        this.hoverGuides[inp].hovering = true;
        let area = this.findGuide(inp);
        if (area && this.marker) {
            let areapos = area.getBoundingClientRect();
            // let markerpos = this.marker.getBoundingClientRect();
            this.marker.style.top = ((areapos.top + (areapos.height / 2)) - 50) + 'px';
            this.marker.style.left = ((areapos.left + (areapos.width / 2)) - 50) + 'px';
            // console.log('hover',inp, areapos);
        }
    }
    leave(inp) {
        if (this.hoverGuides[inp] && this.hoverGuides[inp].hovering) {
            this.hoverGuides[inp].hovering = false;
            if (this.marker) {
                this.marker.style.top = '-101px';
                this.marker.style.left = '-101px';
            }
            // console.log('leave',inp);
        }
    }
    close() {
        this.uiManager.toggleQuickGuidePopup(this.guidesMode, false);
    }
    toggleSize() {
        if (this.context) {
            let v = this.context['doShowTipsLarge'];
            v = !v;
            this.context['doShowTipsLarge'] = v;
            this.updateType();
        }
    }
    action(action, guide = null) {
        let data = null;
        if (this.context['actionQuickGuides']) {
            if (guide && guide.data && guide.data == 'form') {
                let el = document.getElementById('quick-guides');
                if (el) {
                    let find = el.getElementsByClassName('fdm-guide-form-data');
                    if (find) {
                        data = {};
                        for (let item of find) {
                            data[item.name] = { name: item.name, value: item.value };
                            // console.log('@@', item, item.name, item.value, item.innerText );
                        }
                    }
                }
            }
            this.context.actionQuickGuides(action, data);
        }
    }
    findGuide(id = '') {
        const el = document.getElementById(id);
        // console.log('! findGuide()',id,el);
        if (el) {
            return el;
        }
        return null;
    }
    clickOn(id = '') {
        // console.log('! clickOn()',id);
        const el = this.findGuide(id);
        if (el) {
            el.click();
        }
    }
    conditional(c) {
        const tokens = ('' + c).split(' ');
        let ret = false;
        if (tokens) {
            tokens.forEach(token => {
                const splitEquals = ('' + token).split('=');
                if (splitEquals && splitEquals.length > 1) {
                    const left = splitEquals[0].trim();
                    const right = splitEquals[1].trim();
                    if (left && right) {
                        if (left == 'class' && ('' + this.guidesClass).trim() == right) {
                            ret = true;
                        }
                        else if (left == 'mode' && ('' + this.guidesMode).trim() == right) {
                            ret = true;
                        }
                        else if (left == 'state' && ('' + this.state).trim() == right) {
                            ret = true;
                        }
                    }
                }
            });
        }
        return ret;
    }
    autofill(name) {
        if (this.context && this.context.fourD) {
            switch (name) {
                case 'NAME':
                    if (this.context.fourD.activeUser) {
                        return this.context.fourD.activeUser.name;
                    }
                    break;
                case 'EMAIL':
                    if (this.context.fourD.activeUser) {
                        return this.context.fourD.activeUser.email;
                    }
                    break;
                case 'USER_ID':
                    if (this.context.fourD.activeUser) {
                        return this.context.fourD.activeUser.id;
                    }
                    break;
                case 'ACCOUNT_ID':
                    if (this.context.fourD.activeTeam) {
                        return this.context.fourD.activeTeam.id;
                    }
                    break;
            }
        }
        return '';
    }
}
exports.QuickGuidesComponent = QuickGuidesComponent;
